<template>
  <div class="login-phone-container">
    <div class="content">
      <VImage
        :src="require('@/assets/logo-white.png')"
        class="logo"
      />
      <div class="phone">{{ phone }}</div>
      <div class="btn">本机号码一键登陆</div>
      <div class="btn-text">切换其他手机号码</div>
      <Checkbox v-model="checked" class="protocol">
        <div class="text">
          登录代表您已详细阅读，理解并同意《天翼账号服务
          与与隐私协议》和《云库优品用户协议》《个人信息
          保护政策》并使用本机号码登录
        </div>
      </Checkbox>
    </div>
  </div>
</template>

<script>
import {
  Checkbox,
  Image as VImage
} from 'vant'
export default {
  components: { Checkbox, VImage },
  data() {
    return {
      phone: '150****7685',
      checked: false
    }
  }
}
</script>

<style lang="less" scoped>
.login-phone-container {
  height: 100vh;
  width: 100vw;
  background: #C82D26;
  display: flex;
  align-items: center;
  .content {
    width: 100%;
    padding: 0 74px;
  }
  .logo {
    width: 265px;
    margin-bottom: 154px;
  }
  .phone {
    font-size: 48px;
    font-weight: bold;
    text-align: center;
    color: #fff;
    line-height: 1;
  }
  .btn {
    color: #C82D26;
    background-color: #fff;
    line-height: 82px;
    border-radius: 82px;
    margin-top: 40px;
  }
  .btn-text {
    text-align: center;
    color: #fff;
    font-size: 26px;
    margin-top: 40px;
  }
  .protocol {
    margin-top: 116px;
    align-items: flex-start;
    & /deep/ .van-checkbox__icon {
      font-size: 28px;
      .van-icon {
        height: 28px;
        width: 28px;
        background: #fff;
      }
      &.van-checkbox__icon--checked {
        .van-icon {
          background: #1989fa;
        }
      }
    }
    & /deep/ .van-checkbox__label {
      margin-left: 20px;
    }
    .text {
      color: #fff;
      text-align: left;
      font-size: 24px;
      line-height: 34px;
    }
  }
}
</style>